module.exports = __webpack_public_path__ + "media/images/pic/brodno/gallery/2021/polkolonie/thumbs/5-1b3368910f4a2d171ec60f2eb66390bc.webp";